import { React, Route, Component, Container, Link, _ } from 'utils';
import { FairStore, StandStore, Creators, App } from 'model';
import { withRouter, Switch } from 'react-router-dom';
import { Back } from 'components';
import './activitypage.less';
import { ActivityWhy, About, Gallery, Jobs, Chat, Giveaway } from 'components';

class ActivityPage extends Component {

	render() {

		var { type, slug, stand } = this.props.match.params;
		var css = ['page', 'activity', 'activities', type];
		var background = FairStore.getBackgroundUrl();
		let fairData = FairStore.getFairData();
		let isFairActive = (fairData) ? (fairData.active) ? fairData.active : false : false;

		var style = {};

		if(background != null) {
			style = {
				backgroundImage: App.url(FairStore.getBackgroundUrl())
			}
		}

		var src = App.resourceUrl('close.svg');
		var standUrl = App.standUrl(slug, stand);
		var standId = StandStore.findStandId(stand);

		return <div className={ css.join(' ') }>
			<div className="menu">
				<nav className="navbar navbar-expand-lg navbar-light bg-light">
					<Back />
					<Link className="close" to={ standUrl }><img src={ src } /></Link>
				</nav>
			</div>
			<div className="box">
				<div className="background">
					<div style={ style }></div>
				</div>
				<div className="container">
					<div className="content">
						<Switch>
							<Route path="/pavilion/:pavilion/stand/:stand/offers" component={ Jobs } />
							<Route path="/pavilion/:pavilion/stand/:stand/why" component={ ActivityWhy } />
							<Route path="/pavilion/:pavilion/stand/:stand/about" component={ About } />
							<Route path="/pavilion/:pavilion/stand/:stand/gallery" component={ Gallery } />
							<Route path="/pavilion/:pavilion/stand/:stand/chat" component={ Chat } />
						</Switch>
						{(isFairActive) ? (
							<Giveaway standId={standId}/>
						) : null}
					</div>
				</div>
			</div>
		</div>
	}
}

export default withRouter(ActivityPage);


// WEBPACK FOOTER //
// ./src/modules/pages/activitypage.js